/* global __NODE__ */
import { breakpoints } from '../config';

let deviceChecker;
if (__NODE__) {
    deviceChecker = require('device');
}

export const SET = '@@device/SET';
export const UPDATE = '@@device/UPDATE';

export function setDevice(userAgent) {
    let currentDevice = null;
    if (deviceChecker) {
        currentDevice = deviceChecker(userAgent).type;
        if (currentDevice === 'phone') {
            currentDevice = 'mobile';
        }
        if (['desktop', 'tablet', 'mobile'].indexOf(currentDevice) === -1) {
            currentDevice = 'desktop';
        }
    }

    return {
        type: SET,
        payload: {
            userAgent,
            currentDevice,
        },
    };
}

export function updateDevice(width) {
    const { mobile, tablet } = breakpoints;

    let currentDevice;

    if (mobile.normal && width <= mobile.normal) {
        currentDevice = 'mobile';
    } else if (tablet && width > mobile.normal && width <= tablet) {
        currentDevice = 'tablet';
    } else {
        currentDevice = 'desktop';
    }

    return {
        type: UPDATE,
        payload: {
            currentDevice,
            width,
        },
    };
}



/** WEBPACK FOOTER **
 ** /src/shared/actions/device.js
 **/